var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project-item"},[_c('app-project-form',{attrs:{"project":_vm.project,"patient":_vm.project.patient}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }